import isHighContrastTheme from './isHighContrastTheme';

export const NEUTRAL_ARTWORK_FILTER = 'grayscale(1) contrast(3)';

export default function resolveNeutralArtworkStyle(theme) {
    return isHighContrastTheme(theme) ? { filter: NEUTRAL_ARTWORK_FILTER } : {};
}
